import {GameModel} from "@nolimitcity/slot-game/bin/model/GameModel";
import {ApiPlugin} from "@nolimitcity/slot-launcher/bin/plugins/ApiPlugin";
import {SYMBOL_NAME} from "../reels/DumpsterFireSymbol";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {DumpsterFire} from "../DumpsterFire";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/utils/server/IData";
import {
    DumpsterFireGameData,
    DumpsterFireInitData,
    DumpsterFireWinTypes,
    IBigWinLevel,
    IWinRatioConfig,
    IWinRatios
} from "./DumpsterFireData";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {APIFeatureBetEventData} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetEventData";
import {APIBetType} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetType";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {BetFeature} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";
import {DumpsterFireGameMode} from "./DumpsterFireGameMode";
import {ISymbol} from "../../core/reel/simplereel/IReelData";

export interface spineConfig {
    spineItem: PIXI.spine.Spine;
    animation: string;
    skin?: string;
    playLoop?: boolean;
    startTime?: number;
    endTime?: number;
}

export interface xBPosition {
    reelId: number,
    rowId: number
}

export class DumpsterFireModel extends GameModel<DumpsterFireInitData, DumpsterFireGameData> {
    public nearWinReels: boolean[] = [false, false, false, false, false, false];
    public isRestore: boolean = false;
    public reels: string[][]
    public winRatio: number;
    public winRatioConfig: IWinRatioConfig;
    public numOfScatter: number[];
    private _xBombPositions: xBPosition[] = [];
    private _xWayInfectiousPositions: number[];
    private _xWayPositions: number[];
    public isFreespin: boolean = false;
    public multiOnXIArray: [number, number][] = [];
    public hitMaxMulti: number[] = [];
    public boostedBetName: string = "";
    public isBBChanged: boolean = false;
    public isNotNoWinRound: boolean = false;
    public isMaxMulti: number[] = [];
    public numberOfScattersOnReel: number[];
    public numberOfScattersOnReelPrev: number[];
    public rowId: number;
    private _isNextAvalanche: boolean = false;
    private _isNormal: boolean = false;
    public scatterCount: number = 0;
    public inActionSpin: boolean = false;
    public explodeSound: string[] = [];
    public firstReelCollapse: boolean = true;
    public firstReelFillUp: boolean = true;
    public symbolCollapsed: boolean[] = [false, false, false, false, false, false];
    public scatterSymArray: ISymbol[] = [];
    public upgradeStop: boolean = false
    public upgradeAvalancheStop: boolean = false;

    public static BASE_THRESHOLDS: number = 15;
    public static DUCK_HUNTER_THRESHOLDS: number = 35;
    public static HAWK_EYE_THRESHOLDS: number = 100;
    public static BIG_GAME_THRESHOLDS: number = 300;
    public static DAY_64_THRESHOLDS: number = 90;
    public static DAY_1024_THRESHOLDS: number = 3000;

    private WIN_RATIOS: IWinRatios = {
        normalWin: [
            {
                ratio: 0,
                duration: 0,
                type: DumpsterFireWinTypes.TINY
            },
            {
                ratio: 1.5,
                duration: 0,
                type: DumpsterFireWinTypes.SMALL
            },
            {
                ratio: 3,
                duration: 1,
                type: DumpsterFireWinTypes.MEDIUM
            },
            {
                ratio: 5,
                duration: 1,
                type: DumpsterFireWinTypes.LARGE
            }
        ],
        bigWin: [
            {
                from: 0,
                to: 25,
                id: 1,
                ratio: 15,
                duration: 3.2,
                type: DumpsterFireWinTypes.BIG_WIN_01
            },
            {
                from: 25,
                to: 50,
                id: 2,
                ratio: 25,
                duration: 3.2,
                type: DumpsterFireWinTypes.BIG_WIN_02
            },
            {
                from: 50,
                to: 100,
                id: 3,
                ratio: 50,
                duration: 3.2,
                type: DumpsterFireWinTypes.BIG_WIN_03
            },
            {
                from: 100,
                to: 500,
                id: 4,
                ratio: 100,
                duration: 3.2,
                type: DumpsterFireWinTypes.BIG_WIN_04
            },
            {
                from: 500,
                to: Number.MAX_VALUE,
                id: 5,
                ratio: 500,
                duration: 3.2,
                type: DumpsterFireWinTypes.BIG_WIN_05
            }
        ]
    };

    constructor(api: ApiPlugin, triggerEvents: boolean = true) {
        super(api, triggerEvents);
        DumpsterFire.apiPlugin.events.on(APIEvent.ACTION_SPINS_BET, (betData: APIFeatureBetEventData) => {
            if (betData.type === APIBetType.FEATURE_BET && betData.featureName !== DumpsterFire.boostedName) {

            }
            for (let index = 0; index < DumpsterFire.model.initData.featureBuyTimesBetValue.length; index++) {
                if (DumpsterFire.model.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                    DumpsterFire.buyFeatureName = betData.featureName;
                    Logger.logDev(DumpsterFire.buyFeatureName);
                    break;
                }
            }
        });
        api.events.once("featureName", (data: string) => this.onFeatureName(data));
        api.events.on(APIEvent.BET, (betData: APIFeatureBetEventData) => this.onBet(betData));
    }

    private onBet(betData: APIFeatureBetEventData): void {
        for (let index: number = 0; index < DumpsterFire.model.initData.featureBuyTimesBetValue.length; index++) {
            if (DumpsterFire.model.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                DumpsterFire.buyFeatureName = betData.featureName;
                break;
            }
        }
    }

    private calculateNeedFillUp(): void {
        let dataValue: string[][] = DumpsterFire.model.initData.reels;
        for (let reelId: number = 0; reelId < dataValue.length; reelId++) {
            for (let rowId: number = 0; rowId < dataValue[reelId].length; rowId++) {
                if (dataValue[reelId][rowId] === "AV") {
                    this.symbolCollapsed[reelId] = true;
                }
            }
        }
    }

    shouldPlayExtraBet(): boolean {
        return this.data.accumulatedRoundWin >= this.data.extraSpinCost &&
            (this.data.nextPlayerInteraction != undefined
                ? this.data.nextPlayerInteraction.playExtraSpin != undefined
                : true);
    }

    private onFeatureName(name: string): void {
        DumpsterFire.buyFeatureName = name;
    }

    private _evaluatedReels: string[][];

    get evaluatedReels(): string[][] {
        return this._evaluatedReels;
    }

    private _explodePositions: number[];

    get explodePositions() {
        return this._explodePositions;
    }

    get explodeXIPos() {
        return this._xWayInfectiousPositions;
    }

    get explodeXWPos() {
        return this._xWayPositions;
    }

    private _allExplodeWinPositions: boolean[][] = [];

    get allExplodeWinPositions(): boolean[][] {
        return this._allExplodeWinPositions;
    }

    public get triggeredFreespins(): boolean {
        return ((this.data.mode.indexOf("NORMAL") > -1) && (this.data.nextMode != DumpsterFireGameMode.NORMAL && this.data.nextMode != DumpsterFireGameMode.EXTRA_SPIN));
    }

    get isXBombPresent() {
        return this.isXBPresent();
    }

    public get isNextAvalncheMode(): boolean {
        return this._isNextAvalanche;
    }

    public get isLuckyDraw(): boolean {
        return DumpsterFire.buyFeatureName === "LUCKY_DRAW";
    }

    public calculateWinPositions(winData: IBetWayWinData): boolean[][] {
        const allWinPos: boolean[][] = [];
        for (let reelId: number = 0; reelId < this.evaluatedReels.length; reelId++) {
            allWinPos.push([]);
            for (let rowId: number = 0; rowId < this.evaluatedReels[reelId].length; rowId++) {
                allWinPos[reelId].push(false);
            }
        }
        for (let reelId: number = 0; reelId < this.evaluatedReels.length; reelId++) {
            for (let rowId: number = 0; rowId < this.evaluatedReels[reelId].length; rowId++) {
                if (winData.symbol === this.evaluatedReels[reelId][rowId] || this.evaluatedReels[reelId][rowId] === SYMBOL_NAME.WILD) {
                    allWinPos[reelId][rowId] = true;
                }
            }
        }
        return allWinPos;
    }

    public getBigWinLevels(ratio: number): IBigWinLevel[] {
        let levels: IBigWinLevel[] = [];
        const length: number = this.WIN_RATIOS.bigWin.length;
        for (let index: number = 0; index < length; index++) {
            if (ratio >= this.WIN_RATIOS.bigWin[index].ratio) {
                levels.push(this.WIN_RATIOS.bigWin[index]);
            }
        }
        return levels;
    }

    public checkXIExpansion(): boolean {
        let needExpansion: boolean = false;
        for (let reelId: number = 0; reelId < DumpsterFire.model.gameData.reels.length; reelId++) {
            for (let rowId: number = 0; rowId < DumpsterFire.model.gameData.reels[reelId].length; rowId++) {
                let symName: string = DumpsterFire.model.gameData.reels[reelId][rowId];
                if (symName === DumpsterFire.model.data.xWaysSymbol || symName === SYMBOL_NAME.X_WAYS) {
                    needExpansion = true;
                    break;
                }
            }
        }
        if (DumpsterFire.model.explodeXIPos.length >= 2) {
            needExpansion = true;
        }
        return needExpansion;
    }

    public static bigWinThresholdReached(): number {
        const activeFeature = DumpsterFire.apiPlugin.betFeatureController.getActiveBetFeature();

        if (!DumpsterFire.model.data.wasFeatureBuy) {
            if (activeFeature?.name === "BOOSTED_BET_STATE_64") {
                return DumpsterFireModel.DAY_64_THRESHOLDS;
            } else if (activeFeature?.name === "BOOSTED_BET_STATE_1024") {
                return DumpsterFireModel.DAY_1024_THRESHOLDS;
            } else {
                return DumpsterFireModel.BASE_THRESHOLDS;
            }
        }

        const featureName = activeFeature?.name || '';

        if (featureName.includes("FREESPIN_3_SCATTERS")) {
            return DumpsterFireModel.DUCK_HUNTER_THRESHOLDS;
        }

        if (featureName.includes("FREESPIN_4_SCATTERS")) {
            return DumpsterFireModel.HAWK_EYE_THRESHOLDS;
        }

        if (featureName.includes("FREESPIN_5_SCATTERS")) {
            return DumpsterFireModel.BIG_GAME_THRESHOLDS;
        }


        if (featureName.includes('LUCKY_DRAW')) {
            const currentMode = DumpsterFire.model.data.upgradedSymbols.length;

            switch (currentMode) {
                case 1:
                    return DumpsterFireModel.DUCK_HUNTER_THRESHOLDS;
                case 2:
                    return DumpsterFireModel.HAWK_EYE_THRESHOLDS;
                default:
                    return DumpsterFireModel.BIG_GAME_THRESHOLDS;
            }
        }

        return DumpsterFireModel.BASE_THRESHOLDS;
    }


    public findUpgradedSymbol(symbolName: string): boolean {
        const upgradedArray: string[] = DumpsterFire.model.data.upgradedSymbols;
        return upgradedArray.some((item: string) => item === symbolName);
    }

    public boostedBetChanged(): void {
        const activeBetFeature: BetFeature | undefined = DumpsterFire.apiPlugin.betFeatureController.getActiveBetFeature();
        if (activeBetFeature?.name === "BOOSTED_BET" || activeBetFeature?.name === "BOOSTED_BET_STATE_2" || activeBetFeature?.name === "BOOSTED_BET_STATE_64" || activeBetFeature?.name === "BOOSTED_BET_STATE_1024") {
            if (activeBetFeature?.name !== this.boostedBetName && activeBetFeature?.name.indexOf("BOOSTED_BET_STATE_") > -1) {
                this.isBBChanged = true;
            } else {
                this.isBBChanged = false;
            }
            this.boostedBetName = activeBetFeature?.name;
        }
    }

    public onGame(data: DumpsterFireGameData): void {
        super.onGame(data);
        this.isRestore = false;
        this.reels = data.reels;
        this._evaluatedReels = data.evaluatedReels;
        this._allExplodeWinPositions = this.calculateExplodeWinPositions(data.scatterWins);
        if (DumpsterFire.model.data.mode.indexOf("FREESPIN") > -1) {
            this.calculateScatter();
            this.winRatio = (data.spinWin / data.playedBetValue);
        } else {
            this.numOfScatter = [];
            this.winRatio = (data.accumulatedRoundWin / data.playedBetValue);
        }
        this.winRatioConfig = this.calculateWinRatioConfig(this.winRatio);
        if (this.findUpgradedSymbol(SYMBOL_NAME.X_BOMB)) {
            this.upgradedXBombEffectedPos();
        } else {
            this.calculateXBEffectedPos();
        }
        if (DumpsterFire.model.boostedBetName.indexOf("BOOSTED_BET") > -1 && (DumpsterFire.model.data.mode === DumpsterFireGameMode.NORMAL && DumpsterFire.model.data.nextMode === DumpsterFireGameMode.NORMAL && (DumpsterFire.model.data.scatterWins.length === 0 || (!this.isXWPresent())))) {
            this.isNotNoWinRound = false;
        }
        this.boostedBetChanged();
        this.isXIPresent();
        this.isXWPresent();
        if (DumpsterFire.model.data.mode === DumpsterFireGameMode.NORMAL) {
            this.resetPrevPosMulti();
            this.isMaxMulti = [];
        }
        this._isNormal = this.isNormal(data.mode);
        this._isNextAvalanche = this.isAvalanche(data.nextMode);
        if (!this.isRestore) {
            this.numberOfScattersOnReel = this.parseScatterNumberOnReels(data.reels, data.reels.length);
            this.nearWinReels = this.parseNearWin(this.numberOfScattersOnReelPrev, this.numberOfScattersOnReel, data.wasFeatureBuy, this._isNormal);
        }
        this.numberOfScattersOnReelPrev = this._isNextAvalanche ? this.parseScatterNumberOnReels(data.reels, data.reels.length) : [0, 0, 0, 0, 0, 0];
    }

    public sum(arr: number[]): number {
        return arr.reduce((a, b) => a + b, 0);
    }

    public calculatePrevMultiPos(): void {
        for (let i: number = 0; i < 6; i++) {
            for (let j: number = 0; j < 5; j++) {
                DumpsterFire.preMultiPosArray[i][j] = DumpsterFire.model.data.positionMultipliers[i][j];
            }
        }
    }

    public resetPrevPosMulti(): void {
        let value: number = 0;
        const activeBetFeature = DumpsterFire.apiPlugin.betFeatureController.getActiveBetFeature();
        if (activeBetFeature?.name === "BOOSTED_BET_STATE_2") {
            value = 2;
        } else if (activeBetFeature?.name === "BOOSTED_BET_STATE_64") {
            value = 64;
        } else if (activeBetFeature?.name === "BOOSTED_BET_STATE_1024") {
            value = 1024;
        }
        for (let i: number = 0; i < 6; i++) {
            for (let j: number = 0; j < 5; j++) {
                if (DumpsterFire.model.boostedBetName.indexOf("BOOSTED_BET_STATE") > -1) {
                    DumpsterFire.preMultiPosArray[i][j] = value;
                } else {
                    DumpsterFire.preMultiPosArray[i][j] = 1;
                }
            }
        }
    }

    protected onInit(data: DumpsterFireInitData): void {
        super.onInit(data);
        this.isRestore = data.isRestoreState;
        this.numberOfScattersOnReelPrev = ArrayHelper.initArrayWithValues(6, () => 0);
        this.numberOfScattersOnReel = this.parseScatterNumberOnReels(data.reels, data.reels.length);
        this.nearWinReels = this.parseNearWinOnRestore(this.numberOfScattersOnReel, data.wasFeatureBuy);
        if (this.isRestore && this.isAvalanche(data.nextMode)) {
            this.calculateNeedFillUp();
            this.numberOfScattersOnReelPrev = this.numberOfScattersOnReel.concat();
        }
    }

    private isNormal(mode: string): boolean {
        return !((mode.indexOf("FREESPIN") > -1 || mode.indexOf("EXTA_SPIN") > -1) && DumpsterFire.model.data.upgradedSymbols.length > 0);
    }

    private isAvalanche(mode: string): boolean {
        return mode.indexOf("AVALANCHE") > -1;
    }

    private parseScatterNumberOnReels(reels: string[][], rowId: number): number[] {
        const scatterNumberOnReels: number[] = [];
        reels.forEach((syms: string[]) => {
            let numberOfScatter: number = 0;
            syms.forEach((sym: string, i: number) => {
                if (i < rowId) {
                    numberOfScatter += (sym === SYMBOL_NAME.SCATTER ? 1 : 0);
                }
            });
            scatterNumberOnReels.push(numberOfScatter);
        });
        return scatterNumberOnReels;
    }

    private parseNearWinOnRestore(prevScatters: number[], wasFeatureBuy: boolean): boolean[] {
        const nearWinReels: boolean[] = ArrayHelper.initArrayWithValues(6, () => false);
        if (!this.isRestore || !this.isNextAvalncheMode || wasFeatureBuy) {
            return nearWinReels;
        }
        let totalScatterNum: number = this.sum(prevScatters);
        if (totalScatterNum >= 2) {
            this.reels.forEach((syms: string[], i: number) => {
                nearWinReels[i] = (prevScatters[i] < 2);
            });
        }
        return nearWinReels;
    }

    private parseNearWin(prevScatters: number[], newScatters: number[], wasFeatureBuy: boolean, isNormal: boolean): boolean[] {
        const nearWinReels: boolean[] = ArrayHelper.initArrayWithValues(6, () => false);
        if (!isNormal) {
            return nearWinReels;
        }
        let newTotalScatterNum: number = this.sum(newScatters);
        let totalScatterNum: number = this.sum(prevScatters),
            hasTwoScatters: boolean = totalScatterNum >= 2;
        if (this.isLuckyDraw) {
            newScatters.forEach((num: number, i: number) => {
                if (newTotalScatterNum === 5 && (DumpsterFire.model.data.mode === DumpsterFireGameMode.NORMAL && (DumpsterFire.model.data.nextMode.indexOf("FREESPIN") > -1 || DumpsterFire.model.data.nextMode === DumpsterFireGameMode.NORMAL_AVALANCHE))) {
                    nearWinReels[i] = (totalScatterNum >= 3 && totalScatterNum < 6);
                } else {
                    nearWinReels[i] = (totalScatterNum >= 3);
                }
                totalScatterNum += num;
                if (totalScatterNum === 5) {
                    totalScatterNum++;
                }
            });
            return nearWinReels;
        }
        if (wasFeatureBuy) {
            if (DumpsterFire.buyFeatureName === "FREESPIN_3_SCATTERS") {
                newScatters.forEach((num: number, i: number) => {
                    if (DumpsterFire.model.data.mode === DumpsterFireGameMode.NORMAL && DumpsterFire.model.data.nextMode.indexOf("FREESPIN") > -1) {
                        nearWinReels[i] = (totalScatterNum >= 3 && totalScatterNum < 6);
                    } else {
                        nearWinReels[i] = (totalScatterNum >= 3);
                    }
                    totalScatterNum += num;
                    if (totalScatterNum === 5) {
                        totalScatterNum++;
                    }
                });
                return nearWinReels;
            } else if (DumpsterFire.buyFeatureName === "FREESPIN_4_SCATTERS") {
                newScatters.forEach((num: number, i: number) => {
                    if (DumpsterFire.model.data.mode === DumpsterFireGameMode.NORMAL && DumpsterFire.model.data.nextMode.indexOf("FREESPIN") > -1) {
                        nearWinReels[i] = (totalScatterNum >= 4 && totalScatterNum < 6);
                    } else {
                        nearWinReels[i] = (totalScatterNum >= 4);
                    }
                    totalScatterNum += num;
                    if (totalScatterNum === 5) {
                        totalScatterNum++;
                    }
                });
                return nearWinReels;
            } else {
                return nearWinReels;
            }
        }
        if (hasTwoScatters) {
            this.reels.forEach((syms: string[], i: number) => {
                nearWinReels[i] = prevScatters[i] < 5;
            });
        } else {
            newScatters.forEach((num: number, i: number) => {
                totalScatterNum += (num - prevScatters[i]);
                nearWinReels[i] = hasTwoScatters && totalScatterNum < 6;
                hasTwoScatters = totalScatterNum >= 2;
                if (totalScatterNum === 5) {
                    totalScatterNum++;
                }
            });
        }
        return nearWinReels;
    }

    private calculateWinRatioConfig(ratio: number): IWinRatioConfig {
        for (let index: number = this.WIN_RATIOS.normalWin.length - 1; index >= 0; index--) {
            if (ratio >= this.WIN_RATIOS.normalWin[index].ratio) {
                return this.WIN_RATIOS.normalWin[index];
            }
        }
        return this.WIN_RATIOS.normalWin[0];
    }

    private isXBPresent(): boolean {
        this._xBombPositions.length = 0;
        for (let reelId: number = 0; reelId < DumpsterFire.model.data.reels.length; reelId++) {
            for (let rowId: number = 0; rowId < DumpsterFire.model.data.reels[reelId].length; rowId++) {
                if (DumpsterFire.model.data.reels[reelId][rowId] === SYMBOL_NAME.X_BOMB) {
                    let temp = {
                        reelId: reelId,
                        rowId: rowId
                    }
                    this._xBombPositions.push(temp);
                }
            }
        }
        return this._xBombPositions.length > 0;
    }

    public isXIPresent(): boolean {
        this._xWayInfectiousPositions = [];
        this.multiOnXIArray.length = 0;
        const reels: string[][] = DumpsterFire.model.data.reels;
        for (let reelId: number = 0; reelId < reels.length; reelId++) {
            for (let rowId: number = 0; rowId < reels[reelId].length; rowId++) {
                const symbol: string = reels[reelId][rowId];
                if (symbol === SYMBOL_NAME.XI) {
                    this._xWayInfectiousPositions.push(6 * reelId + rowId);
                    this.multiOnXIArray.push([DumpsterFire.model.data.xWaysMultipliers[reelId][rowId], 6 * reelId + rowId]);
                }
            }
        }
        return this._xWayInfectiousPositions.length > 0;
    }

    private isXWPresent(): boolean {
        this._xWayPositions = [];
        for (let reelId: number = 0; reelId < DumpsterFire.model.gameData.reels.length; reelId++) {
            for (let rowId: number = 0; rowId < DumpsterFire.model.gameData.reels[reelId].length; rowId++) {
                if (DumpsterFire.model.gameData.reels[reelId][rowId] === SYMBOL_NAME.X_WAYS) {
                    this._xWayPositions.push(6 * reelId + rowId);
                }
            }
        }
        return this._xWayPositions.length > 0;
    }

    private calculateScatter(): boolean {
        this.numOfScatter = [];
        for (let reelId: number = 0; reelId < DumpsterFire.model.gameData.reels.length; reelId++) {
            for (let rowId: number = 0; rowId < DumpsterFire.model.gameData.reels[reelId].length; rowId++) {
                if (DumpsterFire.model.gameData.reels[reelId][rowId] === SYMBOL_NAME.SCATTER) {
                    this.numOfScatter.push(6 * reelId + rowId);
                }
            }
        }
        return this.numOfScatter.length > 0;
    }

    private calculateXBEffectedPos(): void {
        let explodePositions: number[] = [];
        if (this.isXBPresent()) {
            for (let i: number = 0; i < this._xBombPositions.length; i++) {
                explodePositions.push(6 * this._xBombPositions[i].reelId + this._xBombPositions[i].rowId);
                if (DumpsterFire.model.gameData.evaluatedReels[this._xBombPositions[i].reelId][this._xBombPositions[i].rowId - 1]) {
                    explodePositions.push(6 * this._xBombPositions[i].reelId + this._xBombPositions[i].rowId - 1);
                }
                if (DumpsterFire.model.gameData.evaluatedReels[this._xBombPositions[i].reelId][this._xBombPositions[i].rowId + 1]) {
                    explodePositions.push(6 * this._xBombPositions[i].reelId + this._xBombPositions[i].rowId + 1);
                }
                if (this._xBombPositions[i].reelId > 0 && this._xBombPositions[i].reelId !== 0) {
                    if (DumpsterFire.model.gameData.evaluatedReels[this._xBombPositions[i].reelId - 1][this._xBombPositions[i].rowId]) {
                        explodePositions.push(6 * (this._xBombPositions[i].reelId - 1) + this._xBombPositions[i].rowId);
                    }
                    if (this._xBombPositions[i].rowId > 0) {
                        explodePositions.push(6 * (this._xBombPositions[i].reelId - 1) + this._xBombPositions[i].rowId - 1);
                    }
                    if (this._xBombPositions[i].rowId < 5) {
                        explodePositions.push(6 * (this._xBombPositions[i].reelId - 1) + this._xBombPositions[i].rowId + 1);
                    }
                }
                if (this._xBombPositions[i].reelId < 6 && this._xBombPositions[i].reelId !== 5) {
                    if (DumpsterFire.model.gameData.evaluatedReels[this._xBombPositions[i].reelId + 1][this._xBombPositions[i].rowId]) {
                        explodePositions.push(6 * (this._xBombPositions[i].reelId + 1) + this._xBombPositions[i].rowId);
                    }
                    if (this._xBombPositions[i].rowId > 0) {
                        explodePositions.push(6 * (this._xBombPositions[i].reelId + 1) + this._xBombPositions[i].rowId - 1);
                    }
                    if (this._xBombPositions[i].rowId < 5) {
                        explodePositions.push(6 * (this._xBombPositions[i].reelId + 1) + this._xBombPositions[i].rowId + 1);
                    }
                }
            }
            this._explodePositions = explodePositions.filter((val, index) => {
                return explodePositions.indexOf(val) === index;
            });
        }
    }

    private upgradedXBombEffectedPos(): void {
        let explodePositions: number[] = [];

        if (this.isXBPresent()) {
            this._xBombPositions.forEach(position => {
                const reelId: number = position.reelId,
                    rowId: number = position.rowId;
                // Function to add adjacent positions in the same reel
                const addAdjacentPositions = (r: number) => {
                    addPosition(r, rowId);
                    addPosition(r, rowId - 1);
                    addPosition(r, rowId - 2);
                    addPosition(r, rowId + 1);
                    addPosition(r, rowId + 2);
                };

                // Function to add a position if it's within bounds and evaluated
                const addPosition = (r: number, c: number) => {
                    if (DumpsterFire.model.gameData.evaluatedReels[r]?.[c]) {
                        explodePositions.push(6 * r + c);
                    }
                };
                addAdjacentPositions(reelId);
                if (reelId === 0) {
                    addAdjacentPositions(reelId + 1);
                    addAdjacentPositions(reelId + 2);
                } else if (reelId === 1) {
                    addAdjacentPositions(reelId - 1);
                    addAdjacentPositions(reelId + 1);
                    addAdjacentPositions(reelId + 2);
                } else if (reelId === 2 || reelId === 3) {
                    addAdjacentPositions(reelId - 1);
                    addAdjacentPositions(reelId + 1);
                    addAdjacentPositions(reelId - 2);
                    addAdjacentPositions(reelId + 2);
                } else if (reelId === 4) {
                    addAdjacentPositions(reelId - 1);
                    addAdjacentPositions(reelId - 2);
                    addAdjacentPositions(reelId + 1);
                } else if (reelId === 5) {
                    addAdjacentPositions(reelId - 1);
                    addAdjacentPositions(reelId - 2);
                }
            });
            // Remove duplicate positions
            this._explodePositions = Array.from(new Set(explodePositions));
        }
    }

    private calculateExplodeWinPositions(winData: IBetWayWinData[]): boolean[][] {
        const allExplodeWinPos: boolean[][] = [];
        let reelSet: String[][] = this.evaluatedReels
        for (let reelId: number = 0; reelId < reelSet.length; reelId++) {
            allExplodeWinPos.push([]);
            for (let rowId: number = 0; rowId < reelSet[reelId].length; rowId++) {
                allExplodeWinPos[reelId].push(false);
            }
        }
        winData.forEach((winGroup: IBetWayWinData) => {
            let reelWinPositions: boolean[][] = ArrayHelper.initArrayWithValues(DumpsterFire.model.reels.length, () => {
                return ArrayHelper.initArrayWithValues(DumpsterFire.model.reels.length, () => false);
            });
            for (let reelId: number = 0; reelId < reelSet.length; reelId++) {
                for (let rowId: number = 0; rowId < reelSet[reelId].length; rowId++) {
                    if (winGroup.symbol === reelSet[reelId][rowId] || reelSet[reelId][rowId] === SYMBOL_NAME.WILD) {
                        allExplodeWinPos[reelId][rowId] = true;
                        reelWinPositions[reelId][rowId] = true;
                    }
                }
            }
            winGroup.reelWinPositions = reelWinPositions;
        });
        return allExplodeWinPos;
    }
}